import state from './tagtype.state'
import mutations from './tagtype.mutations'
import actions from './tagtype.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
